// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItem300SoftwareTabDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    ConfigurationItemId = ko.observable();
    SoftwareItem = ko.observable<any>();
    PurchaseVendorItem = ko.observable<any>();
    PurchaseVendorId = ko.observable();
    PurchaseVendorName = ko.observable();
    WarrantyTypeId = ko.observable();
    WarrantyTypeName = ko.observable();
    SoftwareName = ko.observable();
    SoftwareId = ko.observable();
    Price = ko.observable<number>();
    Sort = ko.observable();
    Amount = ko.observable<number>();
    Sum = ko.observable();
    Name1 = ko.observable();
    Name2 = ko.observable();
    Number = ko.observable();
    OrderDate = ko.observable();
    DeliveryDate = ko.observable();
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        this.SoftwareItem.subscribe((item) => {
            //set all Fields
            this.ItemChanged();
        });
        this.PurchaseVendorItem.subscribe((item) => {
            //set all Fields
            this.ItemChanged();
        });
        this.Amount.subscribe((value) => {
            this.Sum(this.Amount() * this.Price());
        });
    }
    ItemChanged() {
        return Bao.post("ConfigurationItem300SoftwareTab/GetFieldData", JSON.stringify({
            softwareId: this.SoftwareId(),
            purchaseVendorId: this.PurchaseVendorId()
        })).done(result => {
            if (result.Model != null) {
                //ko.map.fromJS(result.Model, this);
                this.Number(result.Model.Number);
                this.WarrantyTypeId(result.Model.WarrantyTypeId);
                this.WarrantyTypeName(result.Model.WarrantyTypeName);
                this.Name1(result.Model.Name1);
                this.Name2(result.Model.Name2);
                this.Price(result.Model.Price);
                this.Sum(null);
                this.Amount(null);
            }
        });
    }
    loaded() {
    }
}
export default ConfigurationItem300SoftwareTabDialog;